function normalizeName(name) {
  if (!name || typeof name !== 'string') return ''
  return name.trim().replace(/\s+/g, ' ').toLowerCase()
}

function normalizePhone(phone) {
  if (!phone || typeof phone !== 'string') return ''
  return phone.replace(/\D/g, '')
}

function getCatalogOrganizerId(organizer) {
  const catalogId = organizer.organizer_id ?? organizer.organizerId ?? organizer.organizer?.id
  if (catalogId == null || catalogId === '') return null
  return String(catalogId)
}

export function getOrganizerDuplicateKey(organizer) {
  const catalogId = getCatalogOrganizerId(organizer)
  if (catalogId) {
    return `catalog:${catalogId}`
  }

  const name = normalizeName(organizer.name)
  if (!name) return null

  const phone = normalizePhone(organizer.phone)
  return `profile:${name}|${phone}`
}

export function findDuplicateOrganizerIndexes(organizers) {
  const seen = new Map()
  const duplicateIndexes = new Set()

  organizers.forEach((organizer, index) => {
    const key = getOrganizerDuplicateKey(organizer)
    if (!key) return

    if (seen.has(key)) {
      duplicateIndexes.add(seen.get(key))
      duplicateIndexes.add(index)
    } else {
      seen.set(key, index)
    }
  })

  return [...duplicateIndexes].sort((a, b) => a - b)
}

export function validateOrganizersNoDuplicates(organizers) {
  const duplicateIndexes = findDuplicateOrganizerIndexes(organizers)

  if (duplicateIndexes.length === 0) {
    return { valid: true }
  }

  const positions = duplicateIndexes.map(index => index + 1).join(', ')

  return {
    valid: false,
    message: `В разделе «Организаторы» есть одинаковые организаторы (позиции: ${positions})`,
  }
}
